var o;export var Platform=((o={})[o.web=1]="web",o[o.android=2]="android",o[o.ios=3]="ios",o);